(function segmentEvents(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.FullImageViewerState ||
    !global.NewHomeSource.FullImageViewer.Config ||
    !global.NewHomeSource.Modules.tagManager) {
    return;
  }

  /*
  * Dependencies as
  * if (!global.NewHomeSource.SegmentEvents) {
  *   return;
  * }
  */
  const previousSegmentEvents = global.NewHomeSource.SegmentEvents;

  const imageCollection = 'Community';
  const mapCollection = 'Map';
  const tourCollection = 'Tour';
  const interiorCollection = 'Interior';
  const exteriorCollection = 'Exterior';
  const floorPlanCollection = 'FloorPlan';

  /**
   * @constructs NewHomeSource.SegmentEvents
   */
  function SegmentEvents() {
  }

  SegmentEvents.update = function update(data) {
    const eventForSegment = {
      eventType: 'segmentEvent',
    };

    switch (data.Collection) {
      case imageCollection:
        eventForSegment.event = 'Community Image Displayed';
        eventForSegment.image_url = data.Source;
        eventForSegment.image_sequence = data.Index;
        break;
      case mapCollection:
        eventForSegment.event = 'Community Map Displayed';
        eventForSegment.map_id = data.Id;
        eventForSegment.map_sequence = data.Index;
        break;
      case tourCollection:
        eventForSegment.event = '3D tour Displayed';
        eventForSegment.tour_id = data.Id;
        eventForSegment.tour_sequnce = data.Index;
        break;
      case exteriorCollection:
      case interiorCollection:
        eventForSegment.event = 'Home Image Displayed';
        eventForSegment.image_url = data.Source;
        eventForSegment.image_type = data.Collection;
        eventForSegment.image_sequence = data.Index;
        break;
      case floorPlanCollection:
        eventForSegment.event = 'Floorplan Displayed';
        eventForSegment.floorplan_url = data.Source;
        eventForSegment.floorplan_type = data.Type;
        eventForSegment.floorplan_sequence = data.Index;
        break;
      default:
        return;
    }

    if (typeof document.body.dispatchEvent === 'function') {
      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: {
          data: eventForSegment
        }
      }));
    }
  };

  SegmentEvents.logVideo = function logVideo(data) {
    const page = global.NewHomeSource.Modules.tagManager.getFromDataLayer('pageType');
    const eventForSegment = {
      event: page === 'Home_Detail' ? 'Home Video Played' : 'Community Video Played',
      eventType: 'segmentEvent',
      video_id: data.VideoId,
      video_sequence: data.Index,
    };

    if (typeof document.body.dispatchEvent === 'function') {
      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: {
          data: eventForSegment
        }
      }));
    }
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.SegmentEvents to the previous script.
   */
  SegmentEvents.noConflict = function noConflict() {
    global.NewHomeSource.SegmentEvents = previousSegmentEvents;
    return SegmentEvents;
  };

  global.NewHomeSource.FullImageViewerState.add('onImageSet', SegmentEvents);
  global.NewHomeSource.FullImageViewer.SegmentEvents = SegmentEvents;
}(window));
